import ClearAllIcon from '@mui/icons-material/ClearAll';
import CloseIcon from '@mui/icons-material/Close';

export const GetConfirmDialogConfig = (type, action) => {
    const configMap = {
        delete: {
            title: "登録済みサインの削除",
            message: "登録済みのサインを削除します。\n※この操作は元に戻せません。\n\nよろしいですか？",
        },
        clear: {
            title: "サインのクリア",
            message: "現在表示されているサインを消去し、白紙の状態に戻します。\n※登録済みのサインは削除されません。\n\nよろしいですか？",
            confirmIcon: <ClearAllIcon />,
            buttonType: "NomalButton"
        },
        close: {
            title: "確認",
            message: "変更内容は保存されません。\n閉じてよろしいですか？",
            confirmIcon: <CloseIcon />,
            buttonType: "NomalButton"
        }
    };
    const config = configMap[type];
    if (!config) return;
    return {
        open: true,
        title: config.title,
        message: config.message,
        confirmIcon: config.confirmIcon,
        buttonType: config.buttonType,
        confirmClick: action.onConfirm,
        cancelClick: action.onCancel,
    };
}